export const SEO_KEY = 'seo';

export const TITLE_KEY = 'title';
export const DESCRIPTION_KEY = 'description';
export const HEADER_KEY = 'header';
export const BLURB_KEY = 'blurb';
export const BREADCRUMB_LINKS_KEY = 'breadcrumbLinks';
export const RELATED_LINKS_KEY = 'relatedLinks';
export const SEO_AB_RESPONSE_KEY = 'abResponse';
export const SHOULD_INDEX_PAGE = 'shouldIndexPage';
export const HAS_SALP_BLOCK_KEY = 'hasSalpBlockContent';

export const ActionTypes = {
    FETCH_SEO: '@@seo/FETCH_SEO',
    PARSE_SEO_URL: '@@seo/PARSE_SEO_URL',
};
